import type { App } from 'vue'
import { registerComponents } from './components'

export * from './store'

export const createMcp = () => ({
  install: (app: App) => {
    registerComponents(app)

    app.getRouter().addRoute('settings', {
      path: 'mcp',
      name: 'settings-mcp',
      meta: { head: { titleKey: 'mcp.tab' } },
      component: () => import('./components/McpPanel.vue')
    })
  }
})
